import { 
  useMemo, 
  useState, 
  useEffect,
}                                   from 'react';

import useBackListener              from 'functions/history/use_back_listener'
import { connect }                  from 'react-redux';
import { Dispatch }                 from "redux";
import { context }                  from 'context';


import RootComponents               from 'components/RootComponents';
import WhatsAppLink                 from 'components/WhatsappLink';

import RootPages                    from './RootPages';

//import Loader                       from 'components/Loader';
//import Hidden                       from 'components/Hidden';

import useGetUserInfo               from 'functions/get_data/get_user_info';
import useGetTotalLikes             from 'functions/get_data/get_total_likes';
import useGetContent                from 'functions/get_data/get_content';

import useGetGroupContent           from 'functions/get_data/get_group_content';
import useGetUserActivity           from 'functions/get_data/get_user_activity';
import useGetUserVideos             from 'functions/get_data/get_user_videos';

import useGetStudentScores          from 'functions/get_data/useGetStudentScores';
import useGetTutorials              from 'functions/get_data/get_tutorials';
import useGetWhatsappStatus         from 'functions/get_data/get_whatsapp_status';
import useGetUserGuestStatus        from 'functions/get_data/useGetUserGuestStatus';


import useChangeContent             from 'functions/set_data/useChangeContent';
import useSetLang                   from 'functions/set_data/useSetLang';
import useSetChangeContent          from 'functions/set_data/useSetInitialContent';
import useSetData                   from 'functions/set_data/useSetData';
import useShowData                  from 'functions/set_data/useShowData';
import useSetTopics                 from 'functions/set_data/useSetTopics';


import useRecorddError              from 'functions/actions/useRecordError';
import useGoToVideoPage             from 'functions/actions/useGoToVideoPage';

import useModalHooks                from 'functions/modal/useModalhooks';
import useShowTeacherUrlModal       from 'functions/modal/useShowTeacherUrlModal';


import useManualNavigation          from 'functions/handle_key_press/useManualNavigation';

import { useHandleInactivity }      from 'functions/session/handle_user_inactivity';
import { useCountSessionDuration }  from 'functions/session/count_session_duration';





import { initialteacherUrlState }   from 'utils/constants'

import {
         appTopicsArrType,
         contentInfoType,
         teacherUrlStateType,
         pageStateType,
         objType,
       }                            from 'types'

import { CREATE_DATA_SAGA }         from 'actions';

import {
         ActionTypes,
         createDataType,
       }                            from 'actions/types';
import { reducerType }              from 'reducer';

import { 
  componentsStateType, 
  dataStateType 
}                                   from 'reducer/types';
import { SET_CREATE_DATA_ONCE }     from 'actions/dataActions';
import { SET_CHANGE_CONTENT }       from 'actions/contentActions';
import useSize                      from 'functions/ui/useSize';
import useShowLoader                from 'functions/useShowLoader';

import { makeStyles }               from "makeStyles";




const useStyles = makeStyles()(() => ({
    root: {
        position:        'fixed',
        top:             0,
        left:            0,
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        transition:      'opacity 0.6s',
    },
    fallBack: {
      position:        'absolute',
      left:            0,
      height:         '100vh',
      width:          '100vw',
      backgroundColor: '#FFF',
      overflow:        'hidden',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
    },
}))




type rootProps = {
  componentsState:        componentsStateType;
  contentState:           { [key: string]: any };
  dataState:              dataStateType;
  pageState:              pageStateType;
  changeContent:          boolean;
  groupLessonsState:      { [key: string]: any };
  userLessonsState:       { [key: string]: any };
  sessionState:           objType;
  idleTimeState:          objType;
  selectedApp:            contentInfoType;
  setChangeContent:       (payload: boolean) => void,
}


const Root: React.FC<rootProps> = ({
  componentsState,
  contentState,
  dataState,
  pageState,
  changeContent,
  groupLessonsState,
  userLessonsState,
  sessionState,
  idleTimeState,
  selectedApp,
  setChangeContent,
}) => {

  const { classes } = useStyles();



  useSize();
  useBackListener();
  useHandleInactivity(idleTimeState);
  useCountSessionDuration(sessionState);


  //pages & components

  const [goToVideoOnce, setGoToVideoOnce]       = useState(false)
  const [recordErrOnce, setRecordErrOnce]       = useState(false)
  const [recErr, setRecErr]                     = useState(false)

  //content
  const [appTopicsArr, setAppTopicsArr]         = useState([] as appTopicsArrType[])


  //variables
  const [teacherUrlState, setTeacherUrlState]   = useState(initialteacherUrlState as teacherUrlStateType);




  const [ userInfo, dataUpdateState, storageUpdateState ] = useMemo(() => {
    return [
      dataState.userInfo,
      dataState.dataUpdateState,
      dataState.storageUpdateState
    ]
  },[dataState])

  useEffect(() => {

    let unmounted = false;

    if ( !unmounted ) {
      
       setTimeout(() => {
         setRecErr(true);
       },20000)
   }

    return () => { unmounted = true };

  },[])

  
  // set initial lang

  useSetLang();

 // get User Info - - -  -      -      -      -      -      -      -      -      -      -

  useGetUserInfo();

  const guest = useGetUserGuestStatus(userInfo)

  // get Total Likes - - -  -      -      -      -      -      -      -      -      -      -

  useGetTotalLikes(guest);

  // get content - - -  -      -      -      -      -      -      -      -      -      -

  useGetContent();

  // get group content - - -  -      -      -      -      -      -      -      -      -      -

  useGetGroupContent()

  // get User Activity - - -  -      -      -      -      -      -      -      -      -      -

  useGetUserActivity(guest);

  // get User Videos - - -  -      -      -      -      -      -      -      -      -      -

  useGetUserVideos(guest);

  //get tutorials - - - - - - - - - - - -  -      -      -      -      -      -      -      -      -      -

  useGetTutorials();

  // get email registration status - - -

  useGetWhatsappStatus(guest)

  // get student scores - - -  -      -      -      -      -      -      -      -      -      -

  useGetStudentScores(guest, dataUpdateState, userInfo)

  // set Content after receiving it from server  - - -  -      -      -      -      -      -      -      -      -      -

  useSetChangeContent(dataUpdateState)

  // loda real data (received all updated user data from DB)

  useSetData(dataUpdateState, contentState, dataState, guest)

  // show data

  useShowData();

  // show loaders

  const { showLoader, showUpdatingLoader } = useShowLoader(componentsState, dataUpdateState, groupLessonsState, userLessonsState, storageUpdateState, goToVideoOnce);

  // record errors

  useRecorddError(dataState, contentState, recErr, recordErrOnce, showLoader, goToVideoOnce, setRecErr, setRecordErrOnce)
  
  
  // set app info and filters      -      -      -      -      -      -      -      -      -      -

  useChangeContent(componentsState, changeContent, setAppTopicsArr)

  // set menu topics      -      -      -      -      -      -      -      -      -      -

  const { contentTopics, appTopics } = useSetTopics(pageState, appTopicsArr)

  //  go to video page

  useGoToVideoPage(dataUpdateState, userInfo, selectedApp, storageUpdateState, goToVideoOnce, setGoToVideoOnce)

//  modal hooks  -    -      -      -      -      -      -      -      -      -      -      -      -      -

  useModalHooks(userInfo)

  const showTeacherUrlModal = useShowTeacherUrlModal(setTeacherUrlState)

  //  manual navigation-      -      -      -      -      -      -      -      -      -      -      -      -      -

  useManualNavigation(contentTopics, appTopicsArr, setChangeContent, showTeacherUrlModal)


  return (
    <>
        <context.Provider value = {{ 
               userIsGuest:           guest, 
               displayLoader:         showLoader, 
               displayUpdatingLoader: showUpdatingLoader
        }}>
          <div className = { classes.root }>
                <RootPages
                  showTeacherUrlModal = { showTeacherUrlModal }
                />
          </div>
          <RootComponents
              contentTopics      = { contentTopics }
              appTopics          = { appTopics }
              teacherUrlState    = { teacherUrlState }
              goToVideoOnce      = { goToVideoOnce }
          />
        </context.Provider>
    </>
  );
}




const mapStateToProps = (reducer: reducerType) => {



  return {

    componentsState:   reducer.components,
    contentState:      reducer.content,
    pageState:         reducer.page,
    dataState:         reducer.data,
    selectedApp:       reducer.content.selectedApp,
    groupLessonsState: reducer.content.groupLessonsState,
    userLessonsState:  reducer.content.userLessonsState,
    changeContent:     reducer.contentChange.changeContent,
    sessionState:      reducer.session,
    idleTimeState:     reducer.idleTime
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  createData:            (payload: createDataType) => dispatch(CREATE_DATA_SAGA(payload)),
  setChangeContent:      (payload: boolean) => dispatch(SET_CHANGE_CONTENT(payload)),
  setCreateDataOnce:     () => dispatch(SET_CREATE_DATA_ONCE()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);


//lsof -t -i tcp:3000 | xargs kill